import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { MusicPage } from '@/features/music/pages/music-page'
import { plannerSearchSchema } from '@/features/wedding-plan/components/planner-tabs'
import { workspaceQueryOptions } from '@/lib/workspace'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/music')({
  validateSearch: plannerSearchSchema,
  component: Screen,
})
function Screen() {
  const { workspaceSlug } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <MusicPage
      slug={workspaceSlug}
      canWrite={workspace.data?.role === 'owner' || workspace.data?.role === 'editor'}
      weddingName={workspace.data?.wedding?.name || workspace.data?.workspace.name || ''}
    />
  )
}
